import React from "react";
import { useTranslation } from "react-i18next";
import { BLUE_TWELVE, WHITE } from "../../../theme";
import { useStyles } from "../../../components/managementTable/styles";

export const DetailTabs = ({ school }) => {
  const [tab, setTab] = React.useState(0);
  const classes = useStyles();
  const { t } = useTranslation();

  const SCHOOL_DETAIL_TABS = [
    {
      id: 0,
      value: t("text_school_details"),
    }
  ];
  return (
    <div>
      <div className={classes.thead}
        style={{
          display: "flex",
          padding: "10px 0px"
        }}
      >
        {SCHOOL_DETAIL_TABS.map(({ id, value }) => {
          return (
            <div
              key={id}
              role="presentation"
              onClick={() => {
                setTab(id);
              }}
              style={{
                padding: "5px 10px",
                fontWeight: "500",
                cursor: "pointer",
                color: id === tab ? WHITE : BLUE_TWELVE,
                fontSize: 12,
              }}
            >
              {value}
            </div>
          );
        })}
      </div>
      <div style={{ padding: "10px 20px" }}>
        {tab === 0 && (
          <div>
            <DetailItem label={t("text_payee_type")} value={school?.payeeType} />
            <DetailItem label={t("text_name")} value={school?.name} />
            <DetailItem label={t("text_address")} value={school?.address} />
            <DetailItem
              label={t("text_description")}
              value={school?.description || "N/A"}
            />
            <DetailItem label={t("text_school_id")} value={school?.id || ""} />
            <DetailItem label={t("text_merchant_id_number")} value={school?.merchantId} />
          </div>
        )}
      </div>
    </div>
  );
};

const DetailItem = ({ label, value }) => {
  const { t } = useTranslation();
  return (
    <div style={{ padding: "7px 0px" }}>
      <div style={{ color: "gray", fontSize: 12 }}>{label}</div>
      <div
        style={{ fontSize: "0.85vw", fontWeight: 700, textTransform:label === t("text_merchant_id_number") ? "lowercase":  "capitalize" }}
      >
        {value}
      </div>
    </div>
  );
};
